import { createSlice } from "@reduxjs/toolkit";
import { productLastThreeMonthList } from "./productAsyncThunk";

const productLastThreeMonthSlice = createSlice({
  name: "product",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productLastThreeMonthList.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productLastThreeMonthList.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action?.payload?.list];
    },
    [productLastThreeMonthList.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productLastThreeMonthSlice.reducer;
